import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const Note = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${Spacing.S8};
`

export const Logo = styled.span`
  display: flex;
  flex-shrink: 0;
  width: 28px;
  height: 16px;

  svg {
    display: block;
    width: 100%;
    height: 100%;
    overflow: visible;
  }
`
